import React from 'react';
import { Dropdown } from '@heathmont/moon-core-tw';
import SelectFilterOptions from './SelectFilterOptions';
import useSelectFilter from '../../Filters/SelectFilter/useSelectFilter';

type Props = {
  type: FilterSection;
  rules?: string;
  menuItem?: string;
  theme?: string;
};

const SelectFilter: FC<Props> = ({ type, rules, menuItem, theme }) => {
  const filter = useSelectFilter({ type });

  return (
    <Dropdown
      size="lg"
      value={filter.selected ?? []}
      onChange={filter.handleChange}
      multiple
      className={filter.gridArea}
    >
      {({ open }) => (
        <>
          <Dropdown.MultiSelect
            open={open}
            label={
              <div className="text-moon-14 text-trunks">
                {filter.selectText}
              </div>
            }
            placeholder={filter.label.toString()}
            className="text-moon-14"
          />
          <Dropdown.Options className="max-h-96" menuWidth="w-60">
            <SelectFilterOptions
              type={type}
              rules={rules}
              menuItem={menuItem}
              theme={theme}
            />
          </Dropdown.Options>
        </>
      )}
    </Dropdown>
  );
};

export default SelectFilter;
